import Modules from './modules.vue'

export default Modules



// WEBPACK FOOTER //
// ./src/view/main/components/header-bar/modules/index.js